import PropTypes from "prop-types"
import React, { useState } from "react"

import Button from "src/components/Button"
import HeadingSectionHeader from "src/components/Heading/HeadingSectionHeader"

import { useTracker } from "src/hooks/use_tracker"

import CreateJobModal from "./CreateJobModal"
import JobCollapsibleBar from "./JobCollapsibleBar"

const JobsSection = ({
  jobs,
  workOrderSequentialId,
  boatLengthFeet,
  isClosed = false,
}) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false)
  const [recentlyCreatedJobId, setRecentlyCreatedJobId] = useState(null)
  const tracker = useTracker()

  // The header and list-footer buttons open the same modal; the placement tells
  // us which entry point boaters actually reach for.
  const openCreateModal = (placement) => {
    tracker.trackEvent("work_orders:add_job:clicked", {
      placement,
      workOrderSequentialId,
    })
    setIsCreateModalOpen(true)
  }

  return (
    <div>
      <div className="mb-3 flex items-center justify-between">
        <HeadingSectionHeader>Jobs</HeadingSectionHeader>
        {!isClosed && (
          <Button
            variant="primary"
            small
            onClick={() => openCreateModal("header")}
          >
            + Add Job
          </Button>
        )}
      </div>

      <div className="flex flex-col gap-3">
        {jobs.map((job) => (
          <JobCollapsibleBar
            key={job.id}
            job={job}
            workOrderSequentialId={workOrderSequentialId}
            boatLengthFeet={boatLengthFeet}
            defaultOpen={job.id === recentlyCreatedJobId}
            isClosed={isClosed}
          />
        ))}
      </div>

      {jobs.length === 0 && (
        <div className="mb-3 rounded-lg border border-dashed border-gray-300 py-8 text-center text-sm text-gray-500">
          No jobs yet. Add a job to define the scope of this work order.
        </div>
      )}

      {!isClosed && (
        <button
          type="button"
          onClick={() => openCreateModal("list_footer")}
          className="mt-3 flex w-full items-center justify-center gap-1 rounded-lg border-2 border-dashed border-gray-300 bg-white py-3 text-sm font-semibold text-blue-600 hover:bg-gray-100 focus:outline-none"
        >
          + Add Job
        </button>
      )}

      <CreateJobModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        workOrderSequentialId={workOrderSequentialId}
        boatLengthFeet={boatLengthFeet}
        onJobCreated={setRecentlyCreatedJobId}
      />
    </div>
  )
}

JobsSection.propTypes = {
  jobs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string,
      status: PropTypes.string,
      permittedTransitions: PropTypes.arrayOf(PropTypes.string),
    })
  ).isRequired,
  workOrderSequentialId: PropTypes.string.isRequired,
  boatLengthFeet: PropTypes.number,
  isClosed: PropTypes.bool,
}

export default JobsSection
